import { render } from "./ImagePicture.vue?vue&type=template&id=c93dcefa&scoped=true"
import script from "./ImagePicture.vue?vue&type=script&lang=js"
export * from "./ImagePicture.vue?vue&type=script&lang=js"

import "./ImagePicture.vue?vue&type=style&index=0&id=c93dcefa&scoped=true&lang=css"

import exportComponent from "/Users/yalemarc/Documents/yaleapps/simplify-photo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c93dcefa"]])

export default __exports__